module.exports = __webpack_public_path__ + "static/media/mn2.787e84dd.jpeg";